import { render, staticRenderFns } from "./ContactInfo.vue?vue&type=template&id=79ee20e6&scoped=true&"
import script from "./ContactInfo.vue?vue&type=script&lang=js&"
export * from "./ContactInfo.vue?vue&type=script&lang=js&"
import style0 from "./ContactInfo.vue?vue&type=style&index=0&id=79ee20e6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79ee20e6",
  null
  
)

export default component.exports